import router from "src/routes/routes";
import CommonAPIService from "./commonHandler";

const api = new CommonAPIService(router);

export const dspdEmailSettingsService = {
  list: () => api.getCall("/api/dspd_email_settings"),
  saveAll: (settings) => api.postCall("/api/dspd_email_settings", settings),
};
